import gql from 'graphql-tag';

export const DISCOUNT_CODE_FRAGMENT = gql`
  fragment DiscountCodeFragment on DiscountCode {
    id
    code
    discountType
    discountPercentage
    discountAmount
    venueId
    isActive
    validFrom
    validUntil
    maxUses
    currentUses
    minOrderAmount
    description
    createdById
    createdAt
    updatedAt
    deletedAt
    venue {
      id
      name
    }
    createdBy {
      id
      email
      firstName
      lastName
    }
  }
`;

export const DISCOUNT_CODES_BY_VENUE = gql`
  query DiscountCodesByVenueId($venueId: ID!) {
    discountCodesByVenueId(venueId: $venueId) {
      success
      error
      discountCodes {
        ...DiscountCodeFragment
      }
    }
  }
  ${DISCOUNT_CODE_FRAGMENT}
`;

export const DISCOUNT_CODE = gql`
  query DiscountCode($id: ID!) {
    discountCode(id: $id) {
      success
      error
      discountCode {
        ...DiscountCodeFragment
      }
    }
  }
  ${DISCOUNT_CODE_FRAGMENT}
`;

export const FIND_DISCOUNT_CODE_BY_CODE = gql`
  query FindDiscountCodeByCode($code: String!) {
    findDiscountCodeByCode(code: $code) {
      success
      error
      discountCodes {
        ...DiscountCodeFragment
      }
    }
  }
  ${DISCOUNT_CODE_FRAGMENT}
`;
